import { Tooltip, Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';
import React from 'react';

import { BaseThreadFragmentFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

// Exports
type ExternalPartyAlertProps = { thread: BaseThreadFragmentFragmentGQLType };
export const ExternalPartyAlert = ({ thread }: ExternalPartyAlertProps) => {
  const { user } = useUserAuthOrThrow();
  const externalParticipants = thread.participatingOrganizations.filter(
    (org) => org.id !== user.organization.id,
  );
  if (externalParticipants.length === 0) return null;
  return (
    <Tooltip
      label={externalParticipants.map((org) => org.name).join(', ')}
      placement="top-start"
    >
      <Alert size="sm" status="info">
        <AlertIcon />
        <AlertDescription>
          {externalParticipants.length} External{' '}
          {externalParticipants.length === 1 ? 'Party' : 'Parties'}
        </AlertDescription>
      </Alert>
    </Tooltip>
  );
};
